import { ChangeDetectorRef, Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { firstValueFrom, interval, Subscription } from 'rxjs';
import { Sort } from '@angular/material/sort';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { ITimeTrack, ITimeTrackDto, ITimeTrackFilter } from './time-track.interface';
import { TimeTrackService } from './time-track.service';
import { TimeTrackModalComponent } from './time-track-modal/time-track-modal.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { WorkersService } from '../../workers-page/workers/workers.service';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { DialogService } from '../../../shared/services/dialog/dialog.service';
import { TaskHttpService } from '../../tasks-page/tasks/task-http.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { AuthService } from '../../../shared/services/auth.service';
import { AlertService } from '../../../shared/services/alert.service';
import { IConfirmationDialogOptions } from '../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { HelpVideoModalComponent } from '../../../shared/components/help-video-modal/help-video-modal.component';
import { IWorker } from '../../workers-page/workers/workers.interface';
import { WorkersModalComponent } from '../../workers-page/workers/workers-modal/workers-modal.component';
import { watsappURL } from '../../../../env-config';
import { ITask } from '../../tasks-page/tasks/task.interface';
import { TaskSingleComponent } from '../../tasks-page/tasks/task-single/task-single.component';
import { IClient } from '../../clients-page/clients/clients.interface';
import { ClientsModalComponent } from '../../clients-page/clients/clients-modal/clients-modal.component';
import { IInformationDialogOptions } from '../../../shared/services/dialog/information-dialog/information-dialog-options.interface';

let self: any;

@Component({
  selector: 'app-time-track',
  templateUrl: './time-track.component.html',
  styleUrls: ['./time-track.component.css']
})
export class TimeTrackComponent implements OnInit {
  timeTracks: ITimeTrackDto[] = [];
  loading: boolean = true;
  thereAreMore: boolean = false;
  selectedDay!: string;
  filter: ITimeTrackFilter = {
    sort: '',
    skip: 0,
    limit: 10000,
    filters: {
      filterDate: new Date().toISOString() + 'T12:00:00.000Z',
    }
  };
  filterAllData: ITimeTrackFilter = {
    sort: '',
    skip: 0,
    limit: 4,
    filters: {}
  };
  withClockIn!: string;
  withClockOut!: string;
  filtered = false;
  scrollSubscription!: Subscription;
  sortOptions:any = {};
  sortOptionsKeys = Object.keys(this.sortOptions);
  selection: any = { all: false };
  isDev!: boolean;
  curr!: string;
  safeSrc: SafeResourceUrl;
  totalMoreMinTutorial = false;
  showBanner = false;
  querySubscription!: Subscription;

  constructor(
    public _TimeTrackService: TimeTrackService,
    public _WorkersService: WorkersService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    public _TaskHttpService: TaskHttpService,
    private _UtilsService: UtilsService,
    private _AuthService: AuthService,
    private ref: ChangeDetectorRef,
    // private _WebSocketService: WebSocketService,
    private sanitizer: DomSanitizer,
    private _AlertService: AlertService,
    private _route: ActivatedRoute,
  ) {
    self = this;
    this.registerStringBroadcast();
    this.registerQueryParamChanges();
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/d5gYJQCT_nU?si=nQKl-R0Js0q8lzdS");
  }

  registerQueryParamChanges() {
    this.querySubscription = this._route.queryParams.subscribe(params => {
      if (params['id'])
        setTimeout(() => {
          this.getSelectedTimetrack(params['id']);
          this.initTimetracks();
        });
      else {
        this.selectedDay = this._UtilsService.date.toLocale(new Date().toISOString()).substring(0, 10);
        this.initTimetracks();
      }
    })
  }

  async getSelectedTimetrack(id: any) {
    const tt = await firstValueFrom(this._TimeTrackService.getTimeTrack(id));
    this.selectedDay = this._UtilsService.date.toLocale(new Date(tt.clockIn).toISOString()).substring(0, 10);
  }

  ngOnInit() {
    this.selectedDay = this._UtilsService.date.toLocale(new Date().toISOString()).substring(0, 10);
  }

  initTimetracks() {
    this.isDev = this._AuthService.isRole('dev');
    this.filter.company = this._AuthService.companyId();
    this.filterAllData.company = this.filter.company;
    this.getTimeTracksCount();
  }

  getTimeTracksCount() {
    this._TimeTrackService.getTimeTracks(this.filterAllData).subscribe((timeTracks: ITimeTrackDto[]) => {
      this.totalMoreMinTutorial = timeTracks.length <= 0;
      this.getTimeTracks(true);
      // this.initSocketListener();
    });
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    setTimeout(() => {
      console.log(tmp, this.lazySearchTmp);
      if (tmp == this.lazySearchTmp) {
        this.getTimeTracks(true);
      }
    }, 1000);
  }

  calculateDayFilter() {
    const filter: any = this.filter;
    filter.filters.filterDate = this._UtilsService.date.toUTC(this.selectedDay + 'T12:00:00.000Z');
  }

  selectedDayChange() {
    this.getTimeTracks(true);
  }

  deleteBanner() {
    this.showBanner = false;
  }

  getTimeTracks(reset?: boolean) {
    //console.log('getTimeTracks');

    this.calculateDayFilter();
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.timeTracks = [];
      this.clearSelection();
    }
    this._TimeTrackService.getTimeTracks(this.filter).subscribe((timeTracks: ITimeTrackDto[]) => {
      timeTracks.forEach(track => {
        this.groupTimetracks(track);
      });

      console.log(timeTracks)
      if (reset) {
        this.timeTracks = [];
      }
      this.timeTracks = _.concat(this.timeTracks, timeTracks.filter(tt => tt.status != "CANCELLED"));
      const filter: any = this.filter;
      this.thereAreMore = timeTracks.length >= filter.limit;
      //console.log(timeTracks)
      this.loading = false;
      this.showBanner = true;
      this.ref.detectChanges();

      // Calcular el tiempo total de pausas por cada ítem
      this.timeTracks.forEach(task => {
        task.totalBreakTime = this.calculateItemBreakTime(task.timetracks);
      });
    })
  }

  calculateItemBreakTime(timetracks: any[]): number {
    let totalBreakTime = 0;
    let pauseTime: any = null;

    timetracks.forEach(timetrack => {
      if (timetrack.type === 'PAUSE') {
        pauseTime = new Date(timetrack.datetime).getTime();
      } else if (timetrack.type === 'RESUME' && pauseTime) {
        const resumeTime = new Date(timetrack.datetime).getTime();
        totalBreakTime += (resumeTime - pauseTime);
        pauseTime = null; // Reset pauseTime after calculating the break
      }
    });

    // Convert totalBreakTime from milliseconds to minutes if needed
    return Math.floor(totalBreakTime / 60000); // Returns the total break time in minutes
  }


  previousIsSameDate(tt: any, index: number): boolean {
    if (//tt.timetracks[index - 1].type === 'IN' &&
      this.isSameDate(tt.timetracks[index - 1]?.datetime, this.selectedDay)) {
      return true;
    }
    return false;
  }

  isSameDate(datetime: string, selectedDay: string): boolean {
    let date = this._UtilsService.date.toLocale(new Date(datetime).toISOString())
    date = date.substring(0, 10);
    //console.log(date, selectedDay)
    return date === selectedDay;
  }

  groupTimetracks(timeT: any) {
    timeT.groupedData = [];
    let currentGroup: any = null;
    let currentPause: any = null;

    for (let track of timeT.timetracks) {
      if (track.type === 'IN') {
        if (currentGroup) {
          currentGroup.totalPauseTime = currentGroup.pausas.reduce((sum: any, pause: any) => {
            if (pause.pausa && pause.reanudacion) {
              const pauseTime = new Date(pause.reanudacion.datetime).getTime() - new Date(pause.pausa.datetime).getTime();
              return sum + Math.floor(pauseTime / 60000);
            }
            return sum;
          }, 0);
          timeT.groupedData.push(currentGroup);
        }
        currentGroup = {
          entrada: track,
          pausas: [],
          salida: null,
          totalPauseTime: 0,
          pauseInProgress: false // Inicializamos la variable en false
        };
      } else if (track.type === 'OUT') {
        if (currentGroup) {
          currentGroup.salida = track;
          currentGroup.totalPauseTime = currentGroup.pausas.reduce((sum: any, pause: any) => {
            if (pause.pausa && pause.reanudacion) {
              const pauseTime = new Date(pause.reanudacion.datetime).getTime() - new Date(pause.pausa.datetime).getTime();
              return sum + Math.floor(pauseTime / 60000);
            }
            return sum;
          }, 0);
          currentGroup.pauseInProgress = false; // Reiniciar cuando se encuentra una salida
          timeT.groupedData.push(currentGroup);
          currentGroup = null;
        }
      } else if (track.type === 'PAUSE') {
        if (currentGroup) {
          currentPause = { pausa: track, reanudacion: null };
          currentGroup.pauseInProgress = true; // Indicar que la pausa ha comenzado
        }
      } else if (track.type === 'RESUME') {
        if (currentGroup && currentPause) {
          currentPause.reanudacion = track;
          currentGroup.pausas.push(currentPause);
          currentPause = null;
          currentGroup.pauseInProgress = false; // Indicar que la pausa ha terminado
        }
      }
    }

    if (currentGroup) {
      currentGroup.totalPauseTime = currentGroup.pausas.reduce((sum: any, pause: any) => {
        if (pause.pausa && pause.reanudacion) {
          const pauseTime = new Date(pause.reanudacion.datetime).getTime() - new Date(pause.pausa.datetime).getTime();
          return sum + Math.floor(pauseTime / 60000);
        }
        return sum;
      }, 0);
      timeT.groupedData.push(currentGroup);
    }

    timeT.groupedData.forEach((group: any) => {
      if (group.pausas.length === 0) {
        group.noPausas = true;
      }
    });
  }


  loadMore() {
    if (this.thereAreMore && !this.loading) {
      const filter: any = this.filter;
      filter.skip += filter.limit;
      this.getTimeTracks();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  sortTimeTracks(sort: Sort | string) {
    this.filter.sort = (typeof sort == 'string') ? sort : ((sort.direction == 'asc') ? '' : '-') + sort.active;
    this.getTimeTracks(true);
  }

  openFilter() {
    console.log('openFilter');
  }

  clearFilter() {
    this.filter.filters = {};
    this.getTimeTracks(true);
  }

  /*
  openNewTimeTrackModal(timeTrackDto: ITimeTrackDto) {
    let data: any = {
      company: this._AuthService.companyId(),
      worker: timeTrackDto.worker
    };
    if (_.get(timeTrackDto, 'timetracks._id')) data = timeTrackDto.timetracks;
    data.task = { _id: timeTrackDto._id, coordinates: timeTrackDto.coordinates, status: timeTrackDto.status };
    data.outOfRangeIn = timeTrackDto.outOfRangeIn;
    data.outOfRangeOut = timeTrackDto.outOfRangeOut;
    this.openTimeTrackModal(data);
  }
  */

  consoleee(e: any) {
    console.log(e)
  }

  openEditTimeTrackModal(timeTrack: ITimeTrack, timeTrackId: any, showPause: boolean = false) {
    let config = new MatDialogConfig();
    config.width = '400px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(TimeTrackModalComponent, config);
    self.dialogRef.componentInstance.timeTrack = timeTrack;
    //self.dialogRef.componentInstance.editIndex = index;
    //self.dialogRef.componentInstance.editId = timeTrack.timetracks[index]._id;
    self.dialogRef.componentInstance.editId = timeTrackId;
    self.dialogRef.componentInstance.showPause = showPause;
    self.dialogRef.componentInstance.readOnly = false;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getTimeTracks(true);
    });
  }

  openTimeTrackModal(timeTrack: ITimeTrack, readOnly: boolean = false) {
    let config = new MatDialogConfig();
    config.width = '400px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(TimeTrackModalComponent, config);
    self.dialogRef.componentInstance.timeTrack = timeTrack;
    self.dialogRef.componentInstance.readOnly = readOnly;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getTimeTracks(true);
    });
  }

  openDeleteTimeTrackConfirm(timeTrack: ITimeTrack) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Fichaje",
      message: "Esta seguro que desea eliminar este Fichaje?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._TimeTrackService.deleteTimeTrack(timeTrack, true).subscribe(() => {
            this.getTimeTracks(true);
          })
        }
      });
  }

  openHelpVideoModal() {
    let config = new MatDialogConfig();
    config.width = '1100px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(HelpVideoModalComponent, config);
    self.dialogRef.componentInstance.helpLink = this.safeSrc;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getTimeTracks(true);
    });
  }

  clearSelection() {
    this.selection = { all: false }
  }

  checkSomeSelected() {
    this.selection.some = Object.keys(this.selection)
      .filter(el => el !== 'all' && el !== 'some')
      .filter(el => this.selection[el])
      .length > 0;
  }
  
  toggleSelection(_id?: string) {
    if (_id) {
      // Modificar la selección de un elemento individual
      this.selection[_id] = !this.selection[_id];

      // Verificar si todos los elementos están seleccionados
      const allSelected = this.timeTracks.every(timeTrack => {
        const id = timeTrack?._id || '';
        return this.selection[id];
      });

      // Actualizar "seleccionar todos" en base a los elementos seleccionados
      this.selection.all = allSelected;
    } else {
      // Seleccionar o deseleccionar todos
      const newValue = !this.selection.all;
      this.selection = { all: newValue };

      // Aplicar el nuevo estado a todos los elementos
      this.timeTracks.forEach(timeTrack => {
        const id = timeTrack?._id || '';
        this.selection[id] = newValue;
      });
    }

    // Actualizar si hay alguna selección
    this.checkSomeSelected();
  }

  completeClockInOutSelectedConfirm() {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Completar Fichajes Vacíos",
      message: "¿Está seguro de que desea autocompletar los fichajes con los horarios programados de entrada y salida?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    let someTrue = false;
    for (const key in this.selection) {
      if (Object.prototype.hasOwnProperty.call(this.selection, key)) {
        if (this.selection[key] === true) {
          someTrue = true;
          break;
        }
      }
    }
    if (!someTrue) {
      this._AlertService.warn("Seleccione los trabajos que desea completar");
      return
    }

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          const ids = Object.keys(this.selection).filter(el => el != 'all');
          const tasks = this.selection.all ? this.timeTracks : this.timeTracks.filter(task => ids.find(key => {
            const [taskId, workerId] = key.split('-')
            return (taskId == task._id && workerId == task.worker?._id) ? true : false;
          }));
          const toCompleteTaskIds: any = tasks
            .filter(task => task.status == 'OPEN' || task.status == 'QUOTED' || task.status == 'SCHEDULED' || task.status == 'ONGOING')
            .map(task => task._id).filter((taskId, i, tasks) => tasks.indexOf(taskId) === i);
          this.completeTasks(toCompleteTaskIds, async () => {
            for (const task of tasks) await this.completeClockInOut(task, false)
            this.getTimeTracks(true);
          })
        }
      });
  }

  // // Helper function to format milliseconds to 'h m s' or 'h m' or 'm' as needed
  // formatTime(milliseconds: number): string {
  //   const totalSeconds = Math.floor(milliseconds / 1000);
  //   const hours = Math.floor(totalSeconds / 3600);
  //   const minutes = Math.floor((totalSeconds % 3600) / 60);

  //   let formattedTime = '';

  //   if (hours > 0) {
  //     formattedTime += `${hours}h `;
  //   }

  //   if (minutes > 0) {
  //     formattedTime += `${minutes}m`;
  //   }

  //   return formattedTime.trim();
  // }

  completeClockInOutConfirm(task: any) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Completar Fichajes Vacíos",
      message: "¿Está seguro de que desea autocompletar los fichajes con los horarios programados de entrada y salida?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this.completeTasks([task._id], () => {
            this.completeClockInOut(task);
          })
        }
      });
  }

  async completeClockInOut(task: any, getTasks: boolean = true) {
    let clockIn: any = null, clockOut: any = {
      type: 'OUT', datetime: task.scheduledEnd,
      task: task._id, worker: _.get(task, 'worker._id'),
      company: this._AuthService.companyId(), origin: 'admin'
    };

    if (!(task.timetracks?.length > 0)) {
      console.log('crear IN y OUT');
      clockIn = {
        type: 'IN', datetime: task.scheduledStart,
        task: task._id, worker: _.get(task, 'worker._id'),
        company: this._AuthService.companyId(), origin: 'admin'
      }
    }
    else {
      if (task.timetracks[task.timetracks.length - 1].type == 'OUT') {
        console.log('no crear NADA');
        clockOut = null;
      }
      else {
        if (task.timetracks[task.timetracks.length - 1].datetime < task.scheduledEnd) {
          console.log('crear solo OUT');
        }
        else {
          console.log('no crear NADA');
          clockOut = null;
        }
      }
    }

    task.loading = true;

    if (clockIn) {
      await firstValueFrom(this._TimeTrackService.createTimeTrack(clockIn));
    }

    if (clockOut) {
      await firstValueFrom(this._TimeTrackService.createTimeTrack(clockOut));
    }

    if (getTasks) this.getTimeTracks(true);

    /*
    const data: any = {
      task: task._id,
      worker: _.get(task, 'worker._id'),
      company: this._AuthService.companyId(),
      clockIn: _.get(task, 'timetracks.clockIn', task.scheduledStart),
      clockOut: _.get(task, 'timetracks.clockOut', task.scheduledEnd),
      origin: !_.get(task, 'timetracks.clockIn') || !_.get(task, 'timetracks.clockOut') ? 'admin' : task.origin
    }

    task.loading = true;
    if (_.get(task, 'timetracks._id')) {
      data._id = _.get(task, 'timetracks._id');
      this._TimeTrackService.updateTimeTrack(data).subscribe((timeTrack) => {
        task.loading = false;
        this.getTimeTracks(true);
      });
    } else {
      this._TimeTrackService.createTimeTrack(data).subscribe((timeTrack) => {
        task.loading = false;
        this.getTimeTracks(true);
      });
    }
    */
  }

  completeTasks(taskIds: string[], callback: any) {
    if (!taskIds.length) return callback();

    // let updated = 0;
    const modalOptions: IConfirmationDialogOptions = {
      title: "Completar",
      message: "¿Desea pasar " + (taskIds.length > 1 ? "estos Trabajos" : "este Trabajo") + " a estado Completado?",
      yesButtonLabel: 'Sí', noButtonLabel: 'No'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe(async (confirmation: any) => {
        if (confirmation) {
          for (const taskId of taskIds) {
            await this._TaskHttpService.updateTask({
              _id: taskId, company: this._AuthService.companyId(), status: 'COMPLETED'
            }).toPromise();
            // updated++;
            // if (updated == taskIds.length) callback();
          }
          callback();
        } else {
          callback();
        }
      });
  }

  openWorkerModal(worker: IWorker) {
    if (!worker._id) return;
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(WorkersModalComponent, config);
    self.dialogRef.componentInstance.worker = worker;
    self.dialogRef.componentInstance.readOnly = true;
    self.dialogRef.componentInstance.showEdit = false;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
    });
  }

  openWorkerWhatsapp(workerId: any) {
    this._WorkersService.getWorker(workerId).subscribe(worker => {
      const phones = _.get(worker, 'phones', []);
      console.log(phones);
      phones.forEach((phone: any) => {
        window.open(watsappURL({ text: '', phone: phone.number }))
      });
    })
  }

  openTaskModal(task: ITask) {
    if (!task._id) return;
    let config = new MatDialogConfig();
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.hasBackdrop = true;
    config.disableClose = true;
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(TaskSingleComponent, config);
    self.dialogRef.componentInstance.task = task;
    self.dialogRef.componentInstance.readOnly = true;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
    });
  }

  openClientModal(client: IClient) {
    if (!client._id) return;
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(ClientsModalComponent, config);
    self.dialogRef.componentInstance.client = client;
    self.dialogRef.componentInstance.readOnly = true;
    self.dialogRef.componentInstance.showEdit = false;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
    });
  }

  openUnderConstructionDialog() {
    const modalOptions: IInformationDialogOptions = {
      title: "Ups!",
      message: "El enlace se encuentra en construccion",
      closeButtonLabel: "Ok"
    };
    this._dialogService.openInformationModal(modalOptions, this._viewContainerRef)
      .subscribe(() => {
        console.log('ok')
      });
  }

  /*
  initSocketListener() {
    let socket = this._WebSocketService.getSocket();

    socket.on('new-timetrack', (payload) => {
      const tasks = this.timeTracks.filter(task => payload.task == task._id);
      tasks.forEach(task => this.completeFromSocket(task, payload));
    })

    socket.on('new-service', (payload) => {
      console.log(payload);
      //this.getTimeTracks(true)
    })

  }
    */

  completeFromSocket(task: any, payload: any) {
    const data: any = {
      task: task._id,
    }

    task.loading = true;
    if (_.get(task, 'timetracks._id')) {
      data._id = _.get(task, 'timetracks._id');
      task.loading = false;
      task.timetracks = payload;
    } else {
      task.loading = false;
      task.timetracks = payload;
    }
  }

  openWhatsapp() {
    window.open(watsappURL({ text: 'Hola. Te envío el enlace de descarga de Manax, la aplicación que empezaremos a usar en la empresa: https://manax.page.link/descarga' }))
  }
}